import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Config from '../../utils/config.service';
import Session from '../../utils/session.service';
import ImageService from '../../services/image.service';
import ProfilePictureService from '../../services/profile-picture.service';
import AngularHelperService from '../../services/angular-helper.service';
import { Input } from '@angular/core';

@Component({
	standalone: true,
	selector: 'item-thumbnail',
	templateUrl: './item-thumbnail.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, FormsModule ]
})
export class ItemThumbnailComponent implements OnInit {
	private config: Config = inject(Config);
	private session: Session = inject(Session);
	private imageService: ImageService = inject(ImageService);
	private profilePictureService: ProfilePictureService = inject(ProfilePictureService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	
	@Input() size: any | undefined;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.user = this.session.getSession().user;
		this.vm.uid = 'itf-' + Date.now();
		
		this.vm.getProfilePictureUrl = this.profilePictureService.getProfilePictureUrl;
		this.vm.upload = this.upload;
	}
	
	onFileSelected(event: Event): void {
		const input = event.target as HTMLInputElement;
		this.upload(input.files);
	}
	
	upload(files) {
		if (!files || !files.length) return;
		
		this.vm.loaderTimeout = this.angularHelperService.createTimer(
			() => { this.vm.processing = true; },
			this.config.getOtherConfig().LOADER_TIMEOUT_INIT
		);
		this.imageService.uploadImage({ file: files[0] }, 'profile', (img) => {
			this.session.updateProfilePicture(img);
			this.vm.picture = img;
			this.clearLoader();
		}, (err) => {
			this.clearLoader();
		});
	}
	
	clearLoader() {
		this.angularHelperService.cancelTimer(this.vm.loaderTimeout);
		if (this.vm.processing) {
			this.angularHelperService.createTimer(
				() => { this.vm.processing = false; },
				this.config.getOtherConfig().LOADER_TIMEOUT_DELAY
			);
		}
	}
	
}